'use client'

import { useTranslations } from 'next-intl'
import { useRouter } from '@/i18n/routing'
import { usePdfCompressorStore } from '@/stores/use-pdf-compressor-store'
import { FileDropZone } from '@/components/shared/FileDropZone'
import { ToolStepIndicator } from '@/components/shared/ToolStepIndicator'
import { trackToolEvent } from '@/lib/utils/analytics'

export function PdfUploadStep() {
    const t = useTranslations('Upload')
    const router = useRouter()
    const addFiles = usePdfCompressorStore(s => s.addFiles)
    const reset = usePdfCompressorStore(s => s.reset)

    const handleFilesAdded = (files: File[]) => {
        reset()
        addFiles(files, f => f.type === 'application/pdf')
        const accepted = files.filter(f => f.type === 'application/pdf')
        if (accepted.length > 0) {
            trackToolEvent('tool_upload_started', {
                tool: 'pdf-compressor',
                file_count: accepted.length,
                file_kind: 'pdf',
            })
        }
        router.push('/compress-pdf/configurar')
    }

    return (
        <div className="mx-auto max-w-4xl">
            <ToolStepIndicator currentStep={1} baseUrl="/compress-pdf" />
            <div className="rounded-3xl bg-white p-4 shadow-2xl shadow-slate-200/50">
                <FileDropZone
                    accept=".pdf,application/pdf"
                    icon="picture_as_pdf"
                    title={t('selectPdfs')}
                    subtitle={t('subtitlePdf')}
                    onFilesAdded={handleFilesAdded}
                />
            </div>
        </div>
    )
}
